import { Table, Tooltip } from 'antd';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as ReportAction from "app/actions/ReportCommunicationProgramAction";
import { useState } from 'react';

function TableScreen() {

    const dispatch = useDispatch();
    const { idSubdirection } = useSelector((state) => state.Auth.employeeById);
    const {
        isLoadingCoummunicationProgramSelect,
        CoummunicationProgramSelect,
        filter,
        pagination,
    } = useSelector((state) => state.ReportCommunicationProgramAction);

    const { current, pageSize, total } = pagination;

    const dataSource = CoummunicationProgramSelect.map(
        (record) => {
            return {
                'key': record.rowNum,
                'rowNum': record.rowNum,
                'specialtyName': record.specialtyOrSystemName,
                'courseName': record.courseName,
                'categoryName': record.categoryName,
                'finished': record.finished,
                'communicated': record.communicated,
                'pending': record.pending,
                'total': record.total,
                'progressPercentage': record.progressPercentage
            }
        }
    );

    const paginationTable =
    {
        defaultCurrent: 1,
        defaultPageSize: 25,
        current: current,
        pageSize: pageSize,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100'],
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    }


    const columns = [
        {
            title: '#',
            dataIndex: 'rowNum',
            key: 'rowNum',
            sorter: false,
            ellipsis: true,
            width: 50
        },
        {
            title: 'Especialidad / Sistema',
            dataIndex: 'specialtyName',
            key: 'specialtyName',
            sorter: true,
            ellipsis: true,
            width: 240
        },
        {
            title: 'Procedimiento / Material de Capacitación',
            dataIndex: 'courseName',
            key: 'courseName',
            sorter: true,
            ellipsis: true,
            width: 350
        },
        {
            title: 'Puesto',
            dataIndex: 'categoryName',
            key: 'categoryName',
            sorter: true,
            ellipsis: true,
            width: 200
        },
        {
            title: 'Aprobados',
            dataIndex: 'finished',
            key: 'finished',
            sorter: true,
            ellipsis: true,
            width: 130,
            align: 'center',
        },
        {
            title: 'Comunicados',
            dataIndex: 'communicated',
            key: 'communicated',
            sorter: true,
            ellipsis: true,
            width: 130,
            align: 'center',
        },
        {
            title: 'Pendientes',
            dataIndex: 'pending',
            key: 'pending',
            sorter: true,
            ellipsis: true,
            width: 130,
            align: 'center',
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            sorter: true,
            ellipsis: true,
            width: 160,
            align: 'center',
        },
        {
            title: 'Cumplimiento',
            dataIndex: 'progressPercentage',
            key: 'progressPercentage',
            sorter: true,
            ellipsis: true,
            width: 130,
            align: 'center',
            render: (text, record) => (
                text ? text + '%': '0%'
            )
        },
    ];


    const handleTableChange = (pagination, filters, sorter) => {
        let obj = {
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            column: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            order: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined
        }
        dispatch(ReportAction.savePagination(obj));

        dispatch(ReportAction.getReportCommunicationProgramGrid({
            offset: (pagination.current - 1) * pagination.pageSize,
            limit: pagination.pageSize,
            sortColumn: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            sortDir: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined,
            idSubdirection: idSubdirection,
            idCommunicationProgram: filter.idCommunicationProgram
        }))
    }

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <Table
            loading={isLoadingCoummunicationProgramSelect}
            columns={columns}
            dataSource={dataSource}
            pagination={paginationTable}
            // scroll={{ y: 700, x: "max-content" }}
            scroll={{ x: 'min-content', y: (height - 420) }}
            size={"small"}
            onChange={handleTableChange}
        />
    )
}

export default TableScreen
